<script setup lang="ts">
import type { PropType } from 'vue';

const props = defineProps({
    caption: { type: String as PropType<string | undefined>, required: false, default: undefined },
    value: { type: [String, Number, null] as PropType<string | number | null | undefined>, required: false, default: undefined },
});

</script>
<template>
    <tr>
        <td>
            <slot name="caption">
                {{ props.caption ?? '' }}
            </slot>
        </td>
        <td class="value-cell">
            <slot>
                <strong>{{ props.value ?? '' }}</strong>
            </slot>
        </td>
    </tr>
</template>
<style scoped>
.value-cell {
    text-align: right;
}
</style>
